import PropTypes from "prop-types";
import Select from "react-select";
import { styled } from "@mui/material/styles";
import travelStylesList from "./TravelStyleList";

const TravelStylePicker = ({
  travelStyleV = {},
  setTravelStyle = () => {},
  setFieldValue = () => {},
}) => {
  const SelectF = styled(Select)(() => ({
    width: "100%",
    fontSize: "15px",
  }));
  const getOptionStyle = (base) => ({
    ...base,
    fontSize: "15px",
  });

  return (
    <SelectF
      key={travelStyleV?.value}
      options={travelStylesList}
      placeholder="Select a travel style"
      value={travelStyleV?.label ? travelStyleV : null}
      onChange={(value) => {
        if (value) {
          setFieldValue("travelStyle", value?.value);
          setTravelStyle(value);
        } else {
          setTravelStyle({});
        }
      }}
      getOptionValue={(option) => `${option.value}`}
      getOptionLabel={(option) => `${option.label}`}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), option: getOptionStyle }}
      isSearchable
      menuPortalTarget={document.body}
    />
  );
};

// typechecking props for BookingConfirmation Picker
TravelStylePicker.propTypes = {
  setTravelStyle: PropTypes.func,
  setFieldValue: PropTypes.func,
  travelStyleV: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default TravelStylePicker;
